/**
 * Gets the build number from VITE_APP_VERSION (last 4 digits)
 * @returns string - The last 4 digits of the version, or empty string if not available
 */
export const getBuildNumber = (): string => {
  const appVersion = import.meta.env.VITE_APP_VERSION;
  if (!appVersion) return '';

  const versionStr = appVersion.toString();
  const len = versionStr.length;

  if (len >= 10) {
    // Take 4 characters ending at the second-to-last character
    return versionStr.slice(len - 6, len - 2);
  }

  // Default: last 4 characters (or the whole string if shorter)
  return versionStr.length >= 4 ? versionStr.slice(-4) : versionStr;
};
